<template>
<div>
  <v-card pa-5>
    <v-expansion-panel expand focusable>
      <v-expansion-panel-content class="exp-panel waitingListWrapper" v-bind:value="true">
        <div slot="header" class="expand-panel-header">
          <!-- <span @click.stop="checkAllBox()">Select All</span> -->

           <span v-if='!toggle || !this.checkedItems.length'
           @click.stop="checkAllWaitings()">Select All</span>
           <span v-else
           @click.stop="emptyCheckedItem()">Deselect All</span>
           <!-- {{checkedItems.length}} -->
           <!-- {{checkedItems.length}} -->

          <span>Waiting</span>

          <span
          class="patientCount">
            <i class="el-icon-date" style="margin-right:10px"></i>Patients: {{Waiting_list_pd.length}}
          </span>
        </div>
        <WaitingList></WaitingList>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>

  <!-- if appointments is > 2  -->
  <!-- for shifts inside appointments Array  -->
  <v-card pa-5 v-for="(shifts,index) in queue_patient_details">
    <v-expansion-panel
    focusable
    expand
    >
      <v-expansion-panel-content v-bind:value="(shifts.is_ongoing === 1 && shifts.info.length) ? true : false" class="exp-panel otherWrappers">
        <div slot="header" class="expand-panel-header">
          <!-- <span @click.stop="checkAllAppointment(shifts)" id="hideTheFuck">Select All</span> -->
          <!-- <span></span> -->
          <span>Appointments ({{moment(shifts.from).format('hh:mm A')}} - {{moment(shifts.to).format('hh:mm A')}})</span>

          <!-- <span class="patientCount">Patients: {{shifts.info.length}}</span> -->
          <span
          class="patientCount">
            Patients: {{shifts.info.length}}
          </span>
        </div>
        <div>
          <v-flex md12>
          <!-- TODO: It's breaking somewhere -->
          <!-- <v-list v-if='shifts.info.length > 0'> -->
          <v-list >
          <draggable
          :id="`shift-${index}`"
          v-model="shifts.info"
          :options="{disable:false,draggable:'.item',group:'lists'}"
          class="minhgt"
          @end="updateAppointmentPosition(index,$event)"
          :move="checkMove">
            <div v-for="patient in shifts.info" class="item">
              <!-- <h1>{{patient.name}}</h1> -->
              <PatientQueue
              :name="patient.name"
              :gender="patient.gender"
              :age="patient.age"
              :city="patient.place"
              :lastVisit="patient.previous_appointment"
              :id="patient.id"
              :person_id='patient.person_id'
              :order='patient.order'
              :profile_status="patient.profile_status"
              :dateTime="patient.booked_time"
              :image="patient.image_new"
              :shift="index"
              :selectPatient="QueuePatientProfile"
              @click="test" />
            </div>
          </draggable>
        </v-list>
            <v-list >
            <h1 style="text-align: center">
              No patient in this queue
            </h1>
          </v-list>
          <!-- TODO: It's breaking somewhere -->
          <!-- <v-list v-else>
            <h1 style="text-align: center">
              No patient in this queue
            </h1>
          </v-list> -->
      </v-flex>
        </div>
        <!-- <div  v-for="Queuelist.info in queue_patient_details" >
        {{Queuelist.id}}
      </div> -->
        <!-- <PatientList></PatientList> -->
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>



  <v-card pa-5>
    <v-expansion-panel expand focusable>
      <v-expansion-panel-content class="exp-panel otherWrappers">
        <div slot="header" class="expand-panel-header">
          <!-- <span @click.stop="checkAllBox()">Select All</span> -->
          <!-- <span @click="checkAllCompleted()">Select All</span> -->
          <!-- <span></span> -->
          <span>Completed</span>
          <!-- <span class="patientCount">Patients: {{queue_completed_pd.length}}</span> -->

          <span
          class="patientCount">
            Patients: {{queue_completed_pd.length}}
          </span>
        </div>
        <CompletedList></CompletedList>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-card>
  <v-dialog max-width="800px" v-model="dialogProfileVisible" :lock-scroll="true" :scrollable="true" >
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogProfileVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ViewProfile :manageProfile="!dialogProfileVisible" :selectedPatients="selectedPatient"></ViewProfile>
    </v-card>
  </v-flex xs12>
</v-dialog>
</div>

</template>
<script>
import $ from 'jquery';
import { mapState, mapMutations, mapActions } from 'vuex';
import PatientList from './PatientList';
import WaitingList from './WaitingList';
import CompletedList from './CompletedList';
import draggable from 'vuedraggable';
import ViewProfile from './viewProfile';
import Patient from './Patient';
import PatientQueue from './PatientQueue';
import { MessageBox, Message } from 'element-ui';
import * as moment from 'moment';

export default {
  name: 'Dashboard',
  components: {
    PatientList,
    WaitingList,
    CompletedList,
    draggable,
    ViewProfile,
    Patient,
    PatientQueue
  },
  // beforeRouteUpdate: (to,from,next)=>{
  //   console.log("as");
  // },
  beforeRouteLeave(to, from, next) {
    /* ! Warn If User selected any pt then empty the select array and move to next page */
    if (this.checkedItems.length > 0) {
      // this.emptyCheckedItems();
      MessageBox.alert(
        'You have selected patient(s), this will undo your previous action. Do you wish to continue?',
        'Warning',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
          showCancelButton: true,
          showClose: false
        }
      )
        .then(() => {
          // Message({
          //   type: 'success',
          //   message: 'Delete completed'
          // });
          this.emptyCheckedItems();
          next();
        })
        .catch(() => {
          // Message({
          //   type: 'info',
          //   message: 'Delete canceled'
          // });
          next(false);
        });
    } else {
      next();
    }
  },
  computed: mapState({
    name: state => state.name,
    checkedItems: state => state.checkedItems,
    // selected: state => state.selected
    Waiting_list_pd: state => state.Waiting_list_pd,
    queue_patient_details: state => state.queue_patient_details,
    queue_completed_pd: state => state.queue_completed_pd
  }),
  data() {
    return {
      checkedNames: false,
      selected_arr: [],
      dialogProfileVisible: false,
      toggle: false,
      moment: moment,
      selectedPatient: {},
      shifts:{}
    };
  },
  mounted() {
    let clinic_id = localStorage.clinic_id;
    this.getdata(clinic_id);
    // this.refetchData();
  },
  methods: {
 QueuePatientProfile(id, shift) {
      console.log(id, shift);
      const patients = this.queue_patient_details[shift].info.filter(
        patient => patient.person_id === id
      );
      this.selectedPatient = patients[0];
      this.dialogProfileVisible = true;
      console.log(patients);
    },
    // refetchData() {
    //   setInterval(() => {
    //     this.$store.dispatch('getdata');
    //   }, 60000);
    // },
    checkAllWaitings() {
      // checkAllW
      this.toggle = !this.toggle;
      this.$store.commit('checkAllWaiting');
    },
    emptyCheckedItem() {
      // checkAllW
      this.toggle = !this.toggle;
      this.$store.commit('emptyCheckedItems');
    },
    checkMove(ev) {
      if (
        ev.to.id == 'completed' ||
        ev.from.id == ev.to.id ||
        ev.draggedContext.element.profile_status === 'Incomplete'
      ) {
        return false;
      }
      return true;
    },
    updateAppointmentPosition(i, ev) {
      const eventIdArray = ev.to.id.split('-');
      const eventToId = Number(eventIdArray[eventIdArray.length - 1]);
      console.log('Update appointment position');
      let payload = {};
      // Dragging inside tab
      if (ev.from.id == ev.to.id) {
        // console.log(ev.from.id)
        // console.log(ev.to.id)
        //   console.log(eventToId)
        //   console.log(this.queue_patient_details[eventToId].info)
        //  // If you drap and drop a element at the end of list then you have to send the previous element's order
        //   if(this.queue_patient_details[eventToId].info.length == ev.newIndex+1){
        //     payload.order = this.queue_patient_details[eventToId].info[ev.newIndex-1].order
        //   }

        //    // If you drag and drop the first element to second element then you have send 0th element's order
        //   else if(ev.oldIndex==0 && ev.newIndex == 1){
        //     payload.order = this.queue_patient_details[eventToId].info[0].order
        //   }

        // //  Otherwise you have to send the next element's order
        //   else{
        //   let o = ev.newIndex > ev.oldIndex ? ev.newIndex-1:ev.newIndex+1;
        //     payload.order=this.queue_patient_details[o].order;
        //   }

        //   payload.qid=this.queue_patient_details[eventToId].info[ev.newIndex].id;
        //   payload.state = null;
        //   this.$store.dispatch('updateQue',payload);
        return true;
      } else {
        // Dragging to other tabs
        payload.state = ev.to.id == 'waiting' ? 1 : 2;

        switch (payload.state) {
          case 1:
            // If you drap and drop a element at the end of list then you have to send the previous element's order
            if (
              this.$store.state.Waiting_list_pd.length == ev.newIndex + 1 &&
              ev.newIndex !== 0
            ) {
              console.log('Last');
              payload.order = this.$store.state.Waiting_list_pd[
                ev.newIndex - 1
              ].order;
            } else if (ev.newIndex === 0) {
              // if newIndex is 0 when moving to empty waiting list send order of 0
              payload.order = this.$store.state.Waiting_list_pd[
                ev.newIndex
              ].order;
            } else {
              // if moved inbetween send newIndex+1
              payload.order = this.$store.state.Waiting_list_pd[
                ev.newIndex + 1
              ].order;
            }
            payload.qid = this.$store.state.Waiting_list_pd[ev.newIndex].id;
            break;
          case 2:
            /*
        Here I change the case to 3 asuming there is no case 2 in
        existing code
         */
            payload.order = this.$store.state.queue_completed_pd[
              newIndex + 1
            ].order;
            payload.qid = this.$store.state.queue_completed_pd[newIndex].id;
        }
        this.$store.dispatch('updateQue', payload);
         setTimeout(function() {
              window.location.reload();
            }, 1000);
      }
    },
    test() {
      console.log('patient component clicked');
    },
    ...mapMutations([
      'checkAllAppointment',
      'checkAllCompleted',
      'checkAllWaiting',
      'emptyCheckedItems',
      'onEnd'
    ]),
    ...mapActions(['getdata', 'updateQueues', 'changeAppointmentPosition']),
    onMove(evt) {
      console.log(evt.to.id);
      // console.log(evt.from.id)
      // if (evt.to.id == "2") {
      //   return false
      // } else if (evt.to.id == "3") {
      //   return false
      // } else {
      //   return true
      // }
    }
  }
};
</script>
<style scoped>
.expand-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.exp-panel > div {
  color: white;
  background-color: #018fff;
}
/* .item {
  border-bottom: 2px solid #fafafa;
  padding: 0.5rem 0rem;
} */
.patient_details {
  display: flex;
  justify-content: space-around;
}

.minhgt {
  min-height: 50px;
}
.patientCount {
  margin-right: 0.5rem;
}
.waitingListWrapper {
  background-color: #215191 !important;
  color: #fff !important;
  font-weight: 600;
  letter-spacing: 0.11px;
}
.otherWrappers {
  background-color: rgb(80, 171, 248) !important;
  color: #fff !important;
  /* font-weight: 600; */
}
.theme--light
  .expansion-panel
  .waitingListWrapper
  .expansion-panel__container
  .expansion-panel__header
  .icon {
  color: #fff !important;
}
.item {
  border-bottom: 0.5px solid #e0e0e0;
  /* padding: 0.5rem 0rem; */
  /* height: 60px; */
}
</style>
<style>
.cursor-pointer {
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/Dashboard.vue